import Vue from 'vue';

export class ToastHelper {
  static Notify(title: string, text: string, duration: number = 5000, type: string = 'success') {
    Vue.notify({
      title,
      type,
      text,
      duration,
    });
  }
}
